module.exports = __webpack_public_path__ + "img/MessageFilled.1b4788bb.png";